import { I18n } from '@calendly/i18n'
import { Body, Popup } from '@calendly/ui/components/popup'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { currentTestStepSelector } from './selectors'
import { ApplyTestSettings } from './test_saml_connection/apply_test_settings'
import { STEPS } from './test_saml_connection/constants'
import { TestConnection } from './test_saml_connection/test_connection'
import { TestIdpInformation } from './test_saml_connection/test_idp_information'

// i18n-tasks-use t('publisher.organization_settings.test_saml_settings.apply_test_settings.title')
// i18n-tasks-use t('publisher.organization_settings.test_saml_settings.connection.title')
// i18n-tasks-use t('publisher.organization_settings.test_saml_settings.idp_information.title')
export const CreateTestConnectionModal = ({ isOpen, onClose }) => {
  const currentTestStep = useSelector(currentTestStepSelector)

  useEffect(() => {
    if (isOpen) {
      window.onbeforeunload = () => true
    } else {
      window.onbeforeunload = null
    }
  }, [isOpen])

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
      title={I18n.t(`publisher.organization_settings.test_saml_settings.${currentTestStep}.title`)}
    >
      <Body>
        {currentTestStep === STEPS.IDP_INFORMATION && <TestIdpInformation onClose={onClose} />}
        {currentTestStep === STEPS.CONNECTION && <TestConnection onClose={onClose} />}
        {currentTestStep === STEPS.APPLY_TEST_SETTINGS && <ApplyTestSettings onClose={onClose} />}
      </Body>
    </Popup>
  )
}
